import { useState } from "react";
import { useTranslations } from "../hooks/useTranslations.ts";
import { webComponent } from "../services/webComponentService.ts";

function AccordionButton({ checkboxId }: { checkboxId: string }) {
	const t = useTranslations();
	const [show, setShow] = useState<boolean>(false);

	function onToggle() {
		setShow((show) => !show);
	}

	return (
		<label
			htmlFor={checkboxId}
			role="button"
			onClick={onToggle}
			className="group relative flex w-full cursor-pointer items-center justify-between py-6 text-left"
			aria-controls="disclosure-1"
			aria-expanded="false"
		>
			<span className="text-sm font-medium text-gray-900">{t.features}</span>
			<span className="ml-6 flex items-center">
				{!show && (
					<svg
						className="block size-6 text-gray-400 group-hover:text-gray-500"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth="1.5"
						stroke="currentColor"
						aria-hidden="true"
						data-slot="icon"
					>
						<path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
					</svg>
				)}
				{show && (
					<svg
						className="block size-6 text-indigo-400 group-hover:text-indigo-500"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth="1.5"
						stroke="currentColor"
						aria-hidden="true"
						data-slot="icon"
					>
						<path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
					</svg>
				)}
			</span>
		</label>
	);
}

export default webComponent("accordion-button", AccordionButton);
